import "./TechnicalResources.module.css";
import Navigation from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import Footer from "@/reusable_sections/Footer";
import ResourcesIntro from "./sections/ResourcesIntro";
import ResourceHub from "./sections/ResourceHub";
import ArticlesLibrary from "./sections/ArticlesLibrary";
import Technicalquotecta from "./sections/Technicalquotecta";
export default function TechnicalResourcesPage() {
  return <div>
      <Navigation />
      <PageBreadcrumb page="TechnicalResources" />
      <ResourcesIntro />
      <ResourceHub />
      <ArticlesLibrary />
      <Technicalquotecta />
      <Footer />
    </div>;
}